import React from "react";
import { Carousel, Col, Row } from "react-bootstrap";
import { recommendations } from "../constants/constants";

function Recommendations() {
  return (
    <>
      {recommendations.length ? (
        <Row className="my-5 py-5">
          <h3
            className="bolder text-center text-white mb-5"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            Recommendations
          </h3>

          <Col lg="12" xl="2"></Col>
          <Col
            lg="12"
            xl="8"
            className="px-0"
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            <Carousel touch indicators={false} keyboard>
              {recommendations.map((rec) => (
                <Carousel.Item key={rec}>
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ height: "500px" }}
                  >
                    <img src={rec} alt={rec} className="recommendation-img" />
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
          <Col lg="12" xl="2"></Col>
        </Row>
      ) : (
        ""
      )}
    </>
  );
}

export default Recommendations;
